import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog} from '@angular/material/dialog';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { environment } from 'src/environments/environment';
import { Constants } from '../constants';
import { LegalInfoService } from '../services/legal-info.service';
import { LocalStorageService } from '../services/local-storage.service';
import { NotificationService } from '../services/notification-service';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './server-error.component.html',
    styleUrls: ['./server-error.component.scss'],
    standalone: false
})
export class ServerErrorComponent implements OnInit, OnDestroy {
  cdnImageUrl: string;
  supportEmailLink: string;
  loginUserInfo: any;
  buttonText: string;
  serverErrorDetails: object | null = null;

  supportEmialAddress: string | null = null;

  constructor(
    private dialogRef: MatDialog,
    private legalInfoService: LegalInfoService,
    private loader: LoaderService,
    private notification: NotificationService,
    private localStorage: LocalStorageService) {
    this.cdnImageUrl = environment.cdnImageServiceUrl;
    this.supportEmailLink = `mailto:${environment.supportEmail}`;
    this.buttonText = Constants.TRY_AGAIN;
    this.dialogRef.closeAll();
    this.supportEmialAddress = environment.supportEmail;
    const errorData = this.localStorage.getItem('Service-Error');
    this.serverErrorDetails = errorData && errorData.length ? JSON.parse(errorData) : null;
  }

  ngOnInit(): void {
    // can perform any logical implemention here if required
   }
  
  ngOnDestroy() {
    this.localStorage.removeItem('Service-Error');
  }

  goBack() {
    history.back();
  }

  reportErrorDetails() {
    this.loader.show();

    if (this.serverErrorDetails === null){
      return;
    }

    const contactData = {
      messageId: this.serverErrorDetails["MessageId"]
    };
    
    this.legalInfoService.contactSupport(contactData).subscribe({
      next: () => {
        this.loader.hide();
        this.serverErrorDetails = null;
        this.notification.success('Error details are successfully submitted.');
      },
      error: () => {
        this.loader.hide();
        this.notification.warn('Failed to report error details.');
      }
    });
  }
}
